// extracted by css-extract-rspack-plugin
export default {"radiosWrapper":"radios-wrapper--AlO0ZVMDg0A5b87I","buttonsWrapper":"buttons-wrapper--_JbUlbbTYE4JKAxU"};